import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { TasksFilter } from "./TasksFilter";
import { TasksSearch } from "./TasksSearch";
import { TasksDaysFilter } from "./TasksDaysFilter";
import { useTasksFilter } from "@/contexts/TasksFilterContext";

export const TasksFilterWrapper = () => {
	const { t } = useTranslation();
	const { showCancelled, setShowCancelled } = useTasksFilter();

	return (
		<div className="flex flex-col gap-3 mb-6">
			<div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
				<TasksSearch />
				<div className="flex flex-wrap gap-2">
					<TasksDaysFilter />
					<TasksFilter />
					<Button
						variant={showCancelled ? "default" : "outline"}
						onClick={() => setShowCancelled(!showCancelled)}
					>
						{showCancelled ? (
							<><Eye className="h-4 w-4 mr-2" />{t("tasks.showCancelled", "Show Cancelled")}</>
						) : (
							<><EyeOff className="h-4 w-4 mr-2" />{t("tasks.hideCancelled", "Show Cancelled")}</>
						)}
					</Button>
				</div>
			</div>
		</div>
	);
};
